import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';
import { Items } from '../../providers/providers';
//import { Http, RequestOptions, Headers } from '@angular/http';

/**
 * Generated class for the AssessmentReportPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  // segment: 'report',
  // priority: 'high'
})
@Component({
  selector: 'page-assessment-report',
  templateUrl: 'assessment-report.html',
})
export class AssessmentReportPage {

  link: string = this.navParams.get('url');
  pdfLink:any;
  options: any;

  constructor(public navCtrl: NavController, public navParams: NavParams
    ,private sanitizer: DomSanitizer
    ,public items: Items) {
    //this.pdfLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.link);
    // let userId = localStorage.getItem('userId');
    // let password = localStorage.getItem('password');
    this.items.getReport(this.link).subscribe(
              (data:any) => { 
              var file3 = new Blob([data._body], {type: 'application/pdf'});
              this.pdfLink = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file3));
              this.options = {
                data:this.pdfLink,
                //url: this.link,
                //httpHeaders: { 'Access-Control-Allow-Origin': true,
                //'Access-Control-Allow-Credentials': true },
                withCredentials: true,
               }
          },
          error => {
              console.log(error);
          }
      );
    
    //console.log(this.link);
  //   
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/assessment-report/assessment-report.ts